import _ from 'lodash'
import BoundLink from './bound-link'
// Layouts
import Section from './layout/section'
// Utils
import slugify from '../utils/slugify'
// Types
import type {ParentCategory} from '../types/ballot'
// Styles
import styles from './question-list.module.scss'

interface QuestionListProps {
  group: ParentCategory | null
}

const QuestionList = ({group}: QuestionListProps) => {
  const groupSlug = slugify(group?.parent_category_name)
  const questions = _.filter(group?.sub_categories, question => Boolean(question?.name))
  const sortedQuestions = (group?.sort_order === 'manual') ? questions : questions?.sort((a, b) => a?.name?.trim()?.localeCompare(b?.name?.trim()))

  return sortedQuestions
    ? (
      <Section
        styleModifiers={[
          '--is-main',
          '--is-display-block',
          '--is-centered-horizontally',
        ]}
      >
        <div className={styles['question-list']}>
          <h2 style={{marginTop: 0}}>Categories</h2>
          {_.map(sortedQuestions, sortedQuestion => (
            <BoundLink
              key={sortedQuestion._id}
              href={`/${groupSlug}/${slugify(sortedQuestion.name)}`}
              shallow={true}
            >
              {sortedQuestion.name}
            </BoundLink>
          ))}
        </div>
      </Section>
    )
    : null
}

export default QuestionList
